import { useSearchParams } from "react-router-dom";
import { DoomCanvas, DoomProps } from "./DoomCanvas";
import { useConnectChain } from "./useConnectChain";
import { ConnectedClient } from "./common";
import { useMatchTimeLeft } from "./useMatchTimeLeft";
import { useEffect } from "react";
import { Transactions } from "./Transactions";

type DoomContainerInput = {
  client: ConnectedClient;
  matchId: number;
  participants: number;
} & Omit<DoomProps, "petName" | "dup">;

export const DoomContainer = ({ client, isHost, extension, map, matchId, participants }: DoomContainerInput) => {
  const { metrics, txs } = useConnectChain({ client, matchId, isHost, participants });
  const timeLeft = useMatchTimeLeft();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (timeLeft === 0) {
      // Not using `navigate` here to force a page reload to unmount the Doom wasm
      setTimeout(() => (window.location.href = "/"), 3000);
    }
  }, [timeLeft]);

  if (timeLeft === 0) {
    return <div>Your time in the arena has come to an end.</div>;
  }

  return (
    <>
      <div className="absolute left-5 top-3 text-xs">
        TPS: {metrics.tps} | Time left in arena: {timeLeft}
      </div>
      <div className="absolute right-5 top-3 z-10">
        <Transactions txs={txs} />
      </div>
      <DoomCanvas
        isHost={isHost}
        extension={extension}
        map={map}
        petName={client.account.address.substring(0, 10)}
        dup={searchParams.get("dup") ?? undefined}
      />
    </>
  );
};
